import { useGetBanner } from '@cxnpl/api/config/config';
import { Alert } from '@cxnpl/ui';

export const Banner = ({ bannerId }: { bannerId: string }) => {
  // @ts-expect-error -- Query param override to prevent CORS block https://stackoverflow.com/a/69611094
  const { data } = useGetBanner({ preventAdBlock: true, bannerId });

  if (!data?.active) return null;

  return (
    <Alert severity="info" multiline>
      {data.message}
    </Alert>
  );
};
